import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { ClearFilterButton, CreateButton, ExportButton, FilterButton } from '../../../../Components/Utils/Buttons';

const FormsApproveLayout = (
  {
    getData = () => { },
    setSearchQuery = () => { },
    CreateAccess = false,
    ImportAccess = false,
    setOpen = () => { },
    children,
    onCreateClick,
    searchValue = "",
    searchFun = () => { },
    isFilter = false,
    setFilterOpen = () => { },
    newfilter = false,
    ClearFilter = () => { },
    neededSearch = false,
    showproject = true,
    isCard = true,
    setViewMode = () => { },
    viewMode = "",
    ExportAccess = true,
    setOpenExport = () => { },
        // total={total}



  }
) => {
  let { pathname } = useLocation()
  const [module, setModule] = useState("")
  const navigate = useNavigate();



  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname == `/settings/formsApprove/survey`) {
      setModule("Survey")

    } else if (pathname == `/settings/formsApprove/inspection`) {
      setModule("Inspection")
    }
  }, [pathname])

  let LinkItem = [
    {
      label: "Survey Form",
      link: `/settings/formsApprove/survey`,
      access: GetAccess("Form_Survey_view"),
    },
    {
      label: "Inspection Form",
      link: `/settings/formsApprove/inspection`,
      access: GetAccess("Form_Inspection_view"),
    },
    {
      label: "Additional Menus",
      link: `/settings/formsApprove/additional-menus`,
      access: GetAccess("Form_Inspection_view"),
    },
  ];





  return (
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">

      <div className="md:flex justify-between w-full ">
        <Breadcrumb
          items={[
            { name: "Forms Approve" },


            { name: module },
          ]}
        />





        <div className=" flex justify-end items-center gap-3 ">
          <form className="flex items-center gap-3 mx-0" onSubmit={getData}>

            {neededSearch && <SearchBar handleChange={searchFun} value={searchValue} />}

          </form>
          {/* {
                screenSize.width >= "1024" &&(<>
                
                {isCard &&

<div className='flex gap-2'>
<div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
<div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
</div>
}
                </>)
              } */}
          {newfilter && (
            <>
              <FilterButton handleClick={() => { setFilterOpen(true); setSearchQuery(""); }} />
              {isFilter && <ClearFilterButton label='Clear' handleClick={ClearFilter} />} </>)}
          {/* {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />} */}
                               {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />}


          {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label={"Add"} /></Link>}
        </div>
      </div>

     <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
        {
          LinkItem && LinkItem.map((item, i) => {
            const isActive = item?.link === pathname;

            return (
              <>
                {
                  item.access && (
                    <Link
                      to={item?.link}
                      key={item?.link}
                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-1
                        ${isActive 
                          ? "bg-baseColor-primary text-white" 
                          : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                        }`}
                    >
                      {item?.label || ""}
                    </Link>
                    // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                  )
                }
              </>
            )
          })
        }
      </div>
 <div className="  rounded-md md:grid grid-cols-4 gap-x-4 text-xs px-2 font-medium mt-0.5">
          
     {/* <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-12 bg-white text-black px-2 flex items-center justify-center">
    Total
  </p>
  <p className="bg-baseColor-primary w-10 text-white px-2 flex items-center justify-center">
    {total || "0"}
  </p>
</div> */}


    </div>
    </div>

      <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]  overflow-hidden ">
        {children}
      </div>
    </div>

  )
}

export default FormsApproveLayout
